/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.BADA_INDEX = {

  '@GT': 
  [
     'GT- ?S52(50|53)!',
     'GT-S53(30|33)!',
     'GT-S5380!',
     'GT-S57(50|53)!',
     'GT-S57(80)!',
     'GT-S72(30|33)!',
     'GT-S7250!',
     'GT-S8500!',
     'GT- ?S8530!',
     'GT- ?S8600!',
  ],
  '@SC': 
  [
     'SCH-F859!',
  ],
  '@SH': 
  [
     'SHW-M410',
  ],
};

/* This file is automatically generated, do not edit manually! */
